import { connect } from 'react-redux';
import { IRootState } from '../../../redux/state';
import CustomerLogDetails from './CustomerLogDetails';

function mapStateToProps(state: IRootState) {
  return {
    customerLog: state.customer.selectedLogline,
  };
}

export default connect(mapStateToProps)(CustomerLogDetails);
